exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".slide-start-download .slide-start-download__desc[data-v-57992fea] {\n  max-width: 600px;\n}\n.slide-start-download .slide-start-download__button[data-v-57992fea] {\n  height: auto;\n  font-size: 18px;\n  line-height: 1.44;\n  padding: 21px 120px;\n}", ""]);

// exports
